export interface FixedNavigationItem {
    id: string;
    categoryname: string;
    icon: string;
    clickHandler: (param?: string) => void;
    condition: boolean;
    url?: string;
}
export interface ICategory {
    categoryid: string;
    categoryname: string;
    index: number;
    url: string;
    fromExtendedMenuRight: boolean;
    isNavigationCategory: boolean;
    isExtendedTopMenuItem: boolean;
    pathname: string;
    signPostingCount: number;
    displayThumbnail: boolean;
    sitecoreData: {
        attributes: {
            icon: string;
        };
        gameThumbnail: {
            gameId?: string;
            title?: string;
        };
    };
    classMap?: { [key: string]: boolean };
}

export interface PillSubNavConfig {
    isTouch: boolean;
    showSearchInTopNavigation: boolean;
    showHomeFixedNavigation: boolean;
    fixednavEnabled: boolean;
    showHomeInTopNavigation: boolean;
    isPromotionPagesEnabled: boolean;
    searchText: string;
    mcPageDefaultHomePageUrl: string;
    promotionLinkText: string;
    extendedTopMenuToRight: boolean;
    enableFixedMobileNavigation: boolean;
    currentUrl: string;
    categoryType: string;
    displayThumbnailMobile: boolean;
    isDefaultCategory: boolean;
    isSignPosting: boolean;
    discoverFeedLmtkey: string;
    displayDiscoverSticker: boolean;
    isBadgeTypeText: boolean;
    categoryStickerName: string;
    badgeIcon: string;
    ForceMobileNav: boolean;
    isBadgeTypeIcon: boolean;
    hideHomeInSubNav: boolean;
    enableVnIconsForPills: boolean;
}

export enum FixedNavIds {
    SEARCH = 'search',
    HOME = 'home',
    HOME_v2 = 'home-v2',
    PROMOTION = 'promotion',
}

export enum FixedNavIcons {
    SEARCH = 'theme-search-i',
    BADGE = 'theme-badge',
}

export enum FixedItemNavigations {
    SHOWHOMEFIXEDNAVIGATION = 'showHomeFixedNavigation',
    FIXEDNAVENABLED = 'fixednavEnabled',
}
